import React, { useState } from "react";
import { ChevronLeft, ChevronRight, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { themes } from "../mock";

const ThemesCarousel = () => {
  const [index, setIndex] = useState(0);
  const perPage = 3;
  const totalPages = Math.ceil(themes.length / perPage);

  const next = () => setIndex((i) => (i + 1) % totalPages);
  const prev = () => setIndex((i) => (i - 1 + totalPages) % totalPages);

  const visible = themes.slice(index * perPage, index * perPage + perPage);

  return (
    <div>
      <div className="flex items-end justify-between mb-8">
        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-semibold text-white">
          <span className="section-line" />Dialogues That Matter
        </h2>
        <div className="hidden md:flex gap-2">
          <button onClick={prev} className="w-12 h-12 rounded-full border border-white/20 text-white hover:bg-[#ff243d] hover:border-[#ff243d] transition flex items-center justify-center">
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button onClick={next} className="w-12 h-12 rounded-full border border-white/20 text-white hover:bg-[#ff243d] hover:border-[#ff243d] transition flex items-center justify-center">
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {visible.map((t, i) => (
          <div key={i} className="group rounded-xl bg-white/[0.04] border border-white/10 p-7 hover:border-[#ff243d]/50 hover:bg-white/[0.07] transition-all duration-300">
            <div className="h-32 -mx-7 -mt-7 mb-6 rounded-t-xl bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] relative overflow-hidden">
              <div className="absolute inset-0 opacity-30" style={{ backgroundImage: "radial-gradient(circle at 70% 30%, #ff243d 0%, transparent 50%)" }} />
              <div className="absolute bottom-3 left-5 text-white/40 text-xs tracking-widest uppercase">Theme 0{i + 1 + index * perPage}</div>
            </div>
            <h3 className="font-display text-2xl text-white font-semibold leading-tight">{t.title}</h3>
            <p className="mt-3 text-sm text-white/65 leading-relaxed">{t.summary}</p>
            <Link to="/programme" className="mt-5 inline-flex items-center gap-1 text-[#ff243d] text-sm font-medium group-hover:gap-2 transition-all">
              Read more <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-center gap-2 mt-10">
        {Array.from({ length: totalPages }).map((_, i) => (
          <button
            key={i}
            onClick={() => setIndex(i)}
            className={`h-1.5 rounded-full transition-all ${i === index ? "w-10 bg-[#ff243d]" : "w-2 bg-white/20"}`}
          />
        ))}
      </div>
    </div>
  );
};

export default ThemesCarousel;
